import { FC, useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { useActivation } from "../../../lib/hooks/useActivation";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
} from "@material-ui/core";

const useStyles = makeStyles(() => ({
  content: {
    fontFamily: "ヒラギノ角ゴ Pro W3",
    fontSize: "12px",
    lineHeight: 1.2,
    "& a": {
      color: "blue",
    },
  },
}));
export type Props = {
  slug: string;
};
/**
 * 製作委員会がプロジェクト紹介にポップアップ表示を入れたいときに使用するコンポーネントです。
 */
export const Popup: FC<Props> = (props: Props) => {
  const classes = useStyles();
  const [popupHtml, setPopupHtml] = useState<string>("");
  const [isOpen, open, close] = useActivation(false);
  useEffect(() => {
    const popupButton = document.querySelector(`.${props.slug}_popup_button`);
    const popupContent = document.querySelector(`.${props.slug}_popup_content`);
    if (popupButton && popupContent) {
      popupButton.addEventListener("click", open);
      setPopupHtml(popupContent.innerHTML as string);
    }
  }, []);
  return (
    <Dialog open={isOpen} fullWidth={true}>
      <DialogContent>
        <div
          className={classes.content}
          dangerouslySetInnerHTML={{
            __html: popupHtml,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button autoFocus onClick={close} color="primary">
          閉じる
        </Button>
      </DialogActions>
    </Dialog>
  );
};
